<template lang="html">
  <b-container>
    <b-row>
      <b-col>
        <h1>Chords</h1>
        <h3>
          I can play
          {{ $store.getters.knownChords.length }} chords in
          {{ $store.getters.ukeTuning }} tuning.
        </h3>
        <h3>
          I can play
          <b-link
            :to="{
              name: 'playalongs-known-chords',
              params: { tuning: $store.getters.ukeTuning }
            }"
          >
            {{ $store.getters.knownChordSongCount.toLocaleString() }}
            songs
          </b-link>
          with these chords.
        </h3>
        <NonStandardTuningWarning
          v-if="$store.getters.ukeTuning == 'G'"
          class="mt-4"
        />
        <b-row>
          <b-col
            v-for="chord in $store.state.chord_list"
            :key="chord.name"
            class="mt-5"
            @click="$store.dispatch('toggleKnownChord', chord.name)"
          >
            <ChordDiagram
              :chord="chord.name"
              :fill-color="returnFillColor(chord.name)"
              :small="false"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ChordDiagram from "@/components/ChordDiagram";
import NonStandardTuningWarning from "@/components/NonStandardTuningWarning";

export default {
  name: "Chords",
  components: {
    ChordDiagram,
    NonStandardTuningWarning
  },
  methods: {
    returnFillColor(chordName) {
      if (this.$store.getters.knownChords.includes(chordName)) {
        return "green";
      }
      return "black";
    }
  }
};
</script>

<style lang="scss" scoped></style>
